import React, { useState, useRef, useContext, useEffect } from 'react';
import {
    Box, Typography, TextField, Button, Select, MenuItem,
    InputLabel, FormControl, Paper, Stack, styled
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { GoogleMap, useJsApiLoader, Marker, Autocomplete } from '@react-google-maps/api';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from './../../../AuthContext/AuthContext';
import { BASE_URL } from './../../../Api/ApiUrls';
import { IconButton, InputAdornment } from '@mui/material';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import FormsBottomNavbar from '../../Post Module/FormsBottomNavbar';
import SearchBar from '../../Post Module/FormsSearchBar';
import {GOOGLEMAPS_API_KEY} from './../../../Api/ApiUrls';
import { CircularProgress } from '@mui/material';
import FullScreenLoader from '../../../FullScreenLoader';
import SuccessAlert from '../../../../Components/Users/Alertpage/SuccessAlert/SuccessAlert';
import FailureAlert from '../../../../Components/Users/Alertpage/FailureAlert/FailureAlert';

const containerStyle = {
    width: '100%',
    height: '300px',
};
    
const GOOGLE_MAPS_API_KEY = GOOGLEMAPS_API_KEY;
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const RedButton = styled(Button)({
    backgroundColor: 'red',
    color: 'white',
    '&:hover': { backgroundColor: '#cc0000' },
});

const GreenButton = styled(Button)({
    backgroundColor: 'green',
    color: 'white',
    '&:hover': { backgroundColor: '#008000' },
});

const VendorEdit = () => {
    const { vendorId } = useParams();
    const { userId } = useContext(AuthContext);
    const navigate = useNavigate();
      const mapRef = useRef(null); 
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
        libraries: ['places'],
    });
const [locationConfirmed, setLocationConfirmed] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        profession: '',
        mobile: '',
        email: '',
        address: '',
        experience: '',
        description: '',
        lat: '',
        long: ''
    });

    const [location, setLocation] = useState({
        lat: 18.387449,
        lng: 78.803236
    });

    const [profilePhoto, setProfilePhoto] = useState(null);
    const [workPhotos, setWorkPhotos] = useState([]);
    const [existingWorkImages, setExistingWorkImages] = useState([]);
    const [existingProfile, setExistingProfile] = useState('');
    const [markerIcon, setMarkerIcon] = useState(null);
    const [address, setAddress] = useState('');
    const autocompleteRef = useRef(null);
    const [loading, setLoading] = useState(false);
        const [showSuccess, setShowSuccess] = useState(false);
        const [showFailure, setShowFailure] = useState(false);
        const [alertMessage, setAlertMessage] = useState("");

    const workerTypes = [
        "Painting", "Carpenter", "Flooring", "AC Technician", "Cleaning maid",
        "Gardener", "Sofa Cleaning", "Water Purifier", "Kitchen/Toilet Cleaning", "Plumbing", "Electrical"
    ];

    useEffect(() => {
        if (isLoaded && window.google) {
            setMarkerIcon({
                url: "data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22%23ff0000%22%20d%3D%22M12%202C8.13%202%205%205.13%205%209c0%205.25%207%2013%207%2013s7-7.75%207-13c0-3.87-3.13-7-7-7zm0%209.5c-1.38%200-2.5-1.12-2.5-2.5s1.12-2.5%202.5-2.5%202.5%201.12%202.5%202.5-1.12%202.5-2.5%202.5z%22%2F%3E%3C%2Fsvg%3E",
                scaledSize: new window.google.maps.Size(40, 40),
                origin: new window.google.maps.Point(0, 0),
                anchor: new window.google.maps.Point(20, 40)
            });
        }
    }, [isLoaded]);

    useEffect(() => {
        const fetchVendorData = async () => {
            try {
                const response = await fetch(`${BASE_URL}/vendors/${vendorId}/`);
                const data = await response.json();
                
                setFormData({
                    name: data.name,
                    profession: data.profession,
                    mobile: data.mobile,
                    email: data.email,
                    address: data.address,
                    experience: data.experience,
                    description: data.description,
                    lat: data.lat,
                    long: data.long
                });

                setLocation({
                    lat: parseFloat(data.lat),
                    lng: parseFloat(data.long)
                });

                setAddress(data.address);
                setExistingProfile(data.profile);
                setExistingWorkImages(data.work_images || []);
            } catch (error) {
                console.error('Error fetching vendor data:', error);
            }
        };

        fetchVendorData();
    }, [vendorId]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleProfilePhotoChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setProfilePhoto(e.target.files[0]);
        }
    };

    const handleWorkPhotosChange = (e) => {
        if (e.target.files) {
            setWorkPhotos(Array.from(e.target.files));
        }
    };

    const onPlaceChanged = () => {
        if (autocompleteRef.current) {
            const place = autocompleteRef.current.getPlace();
            if (place && place.geometry) {
                const newLat = place.geometry.location.lat();
                const newLng = place.geometry.location.lng();

                setLocation({ lat: newLat, lng: newLng });
                setAddress(place.formatted_address);
            }
        }
    };

    const getCurrentLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    setLocation(pos);

                    try {
                        const response = await fetch(
                            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${pos.lat},${pos.lng}&key=${GOOGLE_MAPS_API_KEY}`
                        );
                        const data = await response.json();

                        if (data.status === 'OK' && data.results.length > 0) {
                            setAddress(data.results[0].formatted_address);
                        }
                    } catch (error) {
                        console.error('Error getting address:', error);
                    }
                },
                (error) => {
                    console.error("Error getting current location:", error);
                }
            );
        }
    };

    const handleMapClick = (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        setLocation({ lat, lng });

        if (window.google && window.google.maps) {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                if (status === 'OK' && results[0]) {
                    setAddress(results[0].formatted_address);
                }
            });
        }
    };

    const [deletedWorkImageIds, setDeletedWorkImageIds] = useState([]);

// Updated delete handler
const handleDeleteWorkImage = (imageId) => {
    setDeletedWorkImageIds([...deletedWorkImageIds, imageId]);
    setExistingWorkImages(prev => prev.filter(img => img.id !== imageId));
};

const handleSubmit = async (e) => {
  e.preventDefault();

  console.log('Starting submission. Images to delete:', deletedWorkImageIds);

  setLoading(true); // ✅ START LOADING

  try {
    const formDataToSend = new FormData();
    formDataToSend.append('deleted_image_ids', deletedWorkImageIds.join(','));

    Object.entries({
      ...formData,
      user_id: userId,
      lat: location.lat,
      long: location.lng,
      address: address
    }).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formDataToSend.append(key, value);
      }
    });

    if (profilePhoto) {
      formDataToSend.append('profile', profilePhoto);
    }

    workPhotos.forEach(photo => {
      formDataToSend.append('new_work_images', photo);
    });

    const response = await fetch(`${BASE_URL}/vendors/${vendorId}/`, {
      method: 'PUT',
      body: formDataToSend,
    });

    const result = await response.json();
    console.log('Full response:', result);

    if (!response.ok) {
      throw new Error(result.message || 'Update failed');
    }

    // ✅ Verify image deletion
    if (result.data?.work_images) {
      const remainingIds = result.data.work_images.map(img => img.id);
      const notDeleted = deletedWorkImageIds.filter(id =>
        remainingIds.includes(id)
      );

      if (notDeleted.length > 0) {
        setAlertMessage(`Images with IDs ${notDeleted.join(',')} were not deleted`);
      } else {
        setAlertMessage('Vendor updated successfully!');
         setShowSuccess(true);
        // navigate('/user-vendors');
      }
    } else {
      setAlertMessage('Update completed but could not verify image deletions');
       setShowFailure(true);    
    }

  } catch (error) {
    console.error('Submission error:', error);
    setAlertMessage(error.message);
      setShowFailure(true);   // ✅ show failure popup

  } finally {
    setLoading(false); // ✅ ALWAYS STOP LOADING
  }
};

     const handleBackClick = () => {
        navigate(-1);
    };

    if (!isLoaded) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <Typography>Loading Google Maps...</Typography>
        </Box>;
    }

    return (
        <>
                  <Box
                                                      sx={{
                                                        position: "fixed",
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        zIndex: 1200,
                                                        backgroundColor: "#fff",
                                                        boxShadow: 1,
                                                      }}
                                                    >
        <SearchBar onBackClick={handleBackClick} />
        </Box>
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                pt: 8,
                backgroundColor: 'rgb(239, 231, 221)',
            }}
        >
            <Box
                sx={{
                    flexGrow: 1,
                    p: { xs: 2, sm: 3 },
                    pb: 10,
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <Paper
                    elevation={2}
                    sx={{
                        p: { xs: 2, sm: 3 },
                        mb: 5,
                        width: '100%',
                        maxWidth: '800px',
                        boxSizing: 'border-box', 
                    }}
                    component="form"
                    onSubmit={handleSubmit}
                >
                    <Typography
                        variant="h5"
                        gutterBottom
                        sx={{ fontWeight: 'bold', mb: 3, textAlign: 'center' }}
                    >
                        Edit Vendor
                    </Typography>

                    <FormControl fullWidth sx={{ mb: 3 }}>
                        <InputLabel id="profession-label">Select Profession</InputLabel>
                        <Select
                            labelId="profession-label"
                            label="Select Profession"
                            name="profession"
                            value={formData.profession}
                            onChange={handleInputChange}
                        >
                            {workerTypes.map((type, index) => (
                                <MenuItem key={index} value={type}>{type}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <TextField
                        fullWidth
                        label="Name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        variant="outlined"
                        sx={{ mb: 2 }}
                        required
                    />

                    <TextField
                        fullWidth
                        label="Mobile"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleInputChange}
                        variant="outlined"
                        sx={{ mb: 2 }}
                        required
                    />

                    <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        variant="outlined"
                        sx={{ mb: 2 }}
                        required
                    />

                    <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Location
                        </Typography>
                        <Autocomplete
                            onLoad={(ref) => (autocompleteRef.current = ref)}
                            onPlaceChanged={onPlaceChanged}
                        >
                            <TextField
                                fullWidth
                                label="Search Location"
                                variant="outlined"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={getCurrentLocation} edge="end">
                                                <MyLocationIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Autocomplete>
                    </Box>

                    {/* <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={location}
                        zoom={15}
                        onClick={handleMapClick}
                    >
                        {markerIcon && (
                            <Marker 
                                position={location} 
                                icon={markerIcon}
                            />
                        )}
                    </GoogleMap> */}
                    {/* <div style={{ ...containerStyle, position: 'relative' }}>
  <GoogleMap
    mapContainerStyle={{ width: '100%', height: '100%' }}
    center={location}
    zoom={15}
    onClick={handleMapClick}
    onDragEnd={(map) => {
      if (map) {
        const center = map.getCenter();
        const lat = center.lat();
        const lng = center.lng();
        setLocation({ lat, lng });

        if (window.google && window.google.maps) {
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ location: { lat, lng } }, (results, status) => {
            if (status === 'OK' && results[0]) {
              setAddress(results[0].formatted_address);
            } else {
              setAddress(`Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`);
            }
          });
        }
      }
    }}
  />

 
  <div
    style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -100%)',
      pointerEvents: 'none',
      zIndex: 10,
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 24 24"
    >
      <path
        fill="#ff0000"
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      />
    </svg>
  </div>
</div> */}
<div style={{ ...containerStyle, position: 'relative' }}>
  <GoogleMap
    mapContainerStyle={{ width: '100%', height: '100%' }}
    center={location}
    zoom={15}
    options={{ gestureHandling: 'greedy' }}
    onLoad={(map) => {
      mapRef.current = map;
    }}
    onDragStart={() => {
      // User started moving the map → unconfirm location, turn button red
      setLocationConfirmed(false);
    }}
  />

  {/* Fixed pin at center */}
  <div
    style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -100%)',
      pointerEvents: 'none',
      zIndex: 10,
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
      <path
        fill="#ff0000"
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      />
    </svg>
  </div>

  {/* Confirm location button — red = unconfirmed, green = confirmed */}
  <button
    type="button"
    onClick={() => {
      if (window.google && window.google.maps && mapRef.current) {
        const center = mapRef.current.getCenter();
        const lat = center.lat();
        const lng = center.lng();

        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode(
          { location: { lat, lng } },
          (results, status) => {
            if (status === 'OK' && results[0]) {
              const selectedAddress = results[0].formatted_address;
              setAddress(selectedAddress);
              setFormData(prev => ({
                ...prev,
                location: selectedAddress,
                lat: lat.toString(),
                long: lng.toString(),
              }));
            } else {
              const fallback = `Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`;
              setAddress(fallback);
              setFormData(prev => ({
                ...prev,
                location: fallback,
                lat: lat.toString(),
                long: lng.toString(),
              }));
            }
            // ✅ Mark location as confirmed → button turns green
            setLocationConfirmed(true);
          }
        );
      }
    }}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: locationConfirmed ? 'green' : 'red', // 🔴 red → 🟢 green
      border: 'none',
      borderRadius: '50%',
      width: '44px',
      height: '44px',
      cursor: 'pointer',
      boxShadow: '0 2px 8px rgba(0,0,0,0.4)',
      position: 'absolute',
      right: '10px',
      top: '45%',
      transform: 'translateY(-50%)',
      zIndex: 10,
      transition: 'background-color 0.3s ease', // smooth color change
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
      <path fill="white" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
    </svg>
  </button>
</div>

                    <TextField
                        fullWidth
                        label="Work Experience (years)"
                        name="experience"
                        type="number"
                        value={formData.experience}
                        onChange={handleInputChange}
                        variant="outlined"
                        sx={{ mb: 2, mt: 3 }}
                        required
                    />

                    <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                        Profile Photo
                    </Typography>
                    {existingProfile && !profilePhoto && (
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="caption">Current:</Typography>
                            <img 
                                src={`${BASE_URL}${existingProfile}`} 
                                alt="Profile" 
                                style={{ 
                                    width: '100px', 
                                    height: '100px', 
                                    objectFit: 'cover',
                                    display: 'block',
                                    marginTop: '8px'
                                }} 
                            />
                        </Box>
                    )}
                    <Button component="label" variant="outlined" startIcon={<CloudUploadIcon />} fullWidth sx={{ mb: 3 }}>
                        {profilePhoto ? 'Change Profile Photo' : 'Upload New Profile Photo'}
                        <VisuallyHiddenInput
                            type="file"
                            accept="image/*"
                            onChange={handleProfilePhotoChange}
                        />
                    </Button>

                  <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
    Work Photos
</Typography>
{existingWorkImages.length > 0 && (
    <Box sx={{ mb: 2 }}>
        <Typography variant="caption">Current Work Photos:</Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 1 }}>
            {existingWorkImages.map((image) => (
                <Box key={image.id} sx={{ position: 'relative' }}>
                    <img 
                        src={`${BASE_URL}${image.image}`} 
                        alt="Work" 
                        style={{ 
                            width: '100px', 
                            height: '100px', 
                            objectFit: 'cover' 
                        }} 
                    />
                    <IconButton
                        size="small"
                        sx={{ 
                            position: 'absolute', 
                            top: 0, 
                            right: 0,
                            backgroundColor: 'rgba(255,0,0,0.5)',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: 'red'
                            }
                        }}
                        onClick={() => handleDeleteWorkImage(image.id)}
                    >
                        ×
                    </IconButton>
                </Box>
            ))}
        </Box>
    </Box>
)}
                    <Button component="label" variant="outlined" startIcon={<CloudUploadIcon />} fullWidth sx={{ mb: 3 }}>
    Add More Work Photos
    <VisuallyHiddenInput
        type="file"
        accept="image/*"
        multiple
        onChange={handleWorkPhotosChange}
    />
</Button>

                    <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                        Description
                    </Typography>
                    <TextField
                        fullWidth
                        variant="outlined"
                        multiline
                        rows={4}
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                    />
<>
  {/* 🔥 Full Screen Loader */}
  <FullScreenLoader
    open={loading}
    text="Updating..."
  />

  <Stack
    direction="row"
    spacing={2}
    justifyContent="center"
    sx={{ mt: 3 }}
  >
    <RedButton
      variant="contained"
      size="large"
      sx={{ px: 4, fontWeight: 'bold' }}
      onClick={() => navigate(-1)}
      disabled={loading}
    >
      Cancel
    </RedButton>

    <GreenButton
      variant="contained"
      size="large"
      sx={{ px: 4, fontWeight: 'bold' }}
      type="submit"
      disabled={loading}
    >
      Update
    </GreenButton>
  </Stack>
</>
                </Paper>
            </Box>
             {showSuccess && (
                                                  <SuccessAlert
                                                    message={alertMessage}
                                                    onClose={() => {
                                                      setShowSuccess(false);
                                                      navigate("/user-vendors");
                                                    }}
                                                  />
                                                )}
                                                
                                                {showFailure && (
  <FailureAlert
    message={alertMessage}
    onClose={() => {
      console.log("Closing failure alert");
      setShowFailure(false);
      setAlertMessage("");

    }}
  />
)}
                                              
            <FormsBottomNavbar />
        </Box>
        </>
    );
};

export default VendorEdit;